import i18n from '@/lang/i18n'
import { AgGridColumnType } from '@/shared/models/ag-grid.model'
import { initialCrudModelBaseState, CrudModelPaginatorLaboratory } from '@/shared/models/cruds.models'
import { ConfigurationIncidentsOriginsLaboratoriesResponse } from '@/modules/configurationModule/detail/incidents/incidents-origins/services/incidents-origins-laboratories.dto'
import { PaginatorLaboratoryDatasource } from '@/shared/resources/datasources/paginator/paginator-laboratory-datasource'
import { incidentsOriginsLaboratoriesConfigurationServices } from '@/modules/configurationModule/detail/incidents/incidents-origins/services/incidents-origins-laboratories.service'
import { store } from '@/store/store'
import { ColDef } from '@ag-grid-enterprise/all-modules'

export const columnsDefIncidentsOriginsGrid =
    (): ColDef[] => [
        { type: AgGridColumnType.CUSTOM_CHECKBOX },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.sections.incidentOrigins'),
            colId: 'incidentOrigin.nameTranslationKey',
            field: 'incidentOrigin.name',
            minWidth: 250,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.CHECK_ICON,
            headerName: i18n.tc('configuration.grid.active'),
            field: 'active',
            minWidth: 80,
            flex: 1,
            suppressSizeToFit: true
        }
    ]

export interface IncidentsOriginsGridState extends CrudModelPaginatorLaboratory<ConfigurationIncidentsOriginsLaboratoriesResponse> {
    labId: number
}
export const initialIncidentsOriginsGridState =
    (): IncidentsOriginsGridState => ({
        ...initialCrudModelBaseState(),
        gridUiComponent: 'uicomponent.configuration.local.incidents.incidentsOrigins',
        columnsDef: columnsDefIncidentsOriginsGrid(),
        datasource: new PaginatorLaboratoryDatasource(incidentsOriginsLaboratoriesConfigurationServices, store.getters.labId),
        labId: store.getters.labId
    })
